<template>
  <div>
    <!-- 搜索部分 -->

    <!-- 主体部分  -->
    <div class="clearfix" style="position: relative">
      <!-- 菜单部分 -->
      <el-card class="clearfix ele-card menu-area">
        <!--  导出 新增  -->
        <div style="display:inline-block">
          <el-button type="success" size="mini" @click="editBenefits(0)">新增</el-button>
        </div>
        <!-- 页码 -->
        <div class="fright">
          <el-pagination
            small
            v-if="total > 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="search.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="search.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-card>
      <!-- table部分 -->
      <el-table :data="tableData"
                border
                stripe
                ref="table"
                class="ele-table table-info-area">

        <el-table-column label="广告图ID" align="center" width="200">
          <template slot-scope="scope">
            <p>{{scope.row.advId}}</p>
            <a :href="scope.row.link" target="_blank">关联链接></a>
          </template>
        </el-table-column>

        <el-table-column label="图片" align="center"  width="100">
          <template slot-scope="scope">
            <image-component :image="scope.row.image" width="80" v-popover:popover{{$index}}></image-component>
          </template>
        </el-table-column>

        <el-table-column label="开放时间" align="center" width="350">
          <template slot-scope="scope">
            <p>{{ scope.row.startTime }} ~ {{ scope.row.endTime }}</p>
            <p class="tag is-black" v-if="scope.row.openState==0">未开始</p>
            <p class="tag is-success" v-if="scope.row.openState==1">展示中</p>
            <p class="tag is-light" v-if="scope.row.openState==2">已关闭</p>
          </template>
        </el-table-column>

        <el-table-column label="广告类型" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.advType == 0">banner</p>
            <p v-if="scope.row.advType == 1">弹窗</p>
          </template>
        </el-table-column>

        <el-table-column label="排序号" align="center" width="150px">
          <template slot-scope="scope">
            <el-input style="width: 100px;" size="mini" v-model="scope.row.sort" @change="sortChange(scope.row.advId, scope.row.sort)"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="展示位置" align="center">
          <template slot-scope="scope">
            <p v-for="item in scope.row.showPlace" >{{item}}</p>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <p class="a-button">
              <a class="" @click="editBenefits(scope.row.advId)">编辑</a>
              <a class="a-red" @click="onDelete(scope.row.advId)">删除</a>
            </p>
          </template>
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        search: {
          page: 1,
          pageSize: 20
        },
        total: 0,
        tableData: [],
      };
    },
    mounted(){
      this.getAdvList();
    },
    methods:{
      // 翻页
      handleCurrentChange(page) {
        if (this.search.page !== page) {
          this.search.page = page;
          this.getAdvList();
          window.scrollTo(0, 0);
        }
      },
      // 改变页数
      handleSizeChange(pageSize) {
        this.search.pageSize = pageSize;
        this.getAdvList();
        window.scrollTo(0, 0);
      },
      // 获取广告位列表
      getAdvList() {
        let params = {
          page:this.search.page,
          pageSize:this.search.pageSize,
        }
         HttpRequest.get('/admin.php?method=adv.getMiniAppAdvList', params).then((response) => {
           this.tableData = response.data.list;
           this.total = parseInt(response.data.count);
         });
      },
      sortChange(advId,sort) {
        let params = {
          advId: advId,
          sort: sort
        }
        HttpRequest.get('/admin.php?method=adv.doSaveMiniAppAdvSort', params).then((response) => {
          if (response.result == 0) {
            this.$message('修改成功')
          } else {
            this.$message.error(response.msg);
          }
        });
      },
      // 删除
      onDelete(advId) {
        if (confirm('是否确定删除?')) {
          HttpRequest.get('/admin.php?method=adv.delMiniAppAdv', {advId: advId}).then((response) => {
            if (response.result == 0) {
              this.getAdvList()
            } else {
              this.$message.error(response.msg);
            }
          });
        }
      },
      // 新增/编辑预告
      editBenefits(advId) {
        // 有id则路由传参
        if (advId != 0) {
          this.$router.push({
            name: 'editMiniAppAdv',
            query: {
              advId: advId
            }
          })
        } else {
          this.$router.push({
            name: 'editMiniAppAdv'
          })
        }
      },
    }
  };
</script>

<style lang="less" scoped>
  .dialogImg {
    text-align: center;
  }
  .control {
    margin-bottom: 0;
  }
  .tag{
    display: inline-block;
    align-items: center;
    color: #69707a;
    font-size: 12px;
    height: 24px;
    line-height: 24px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    border-radius: 12px;
  }
  .is-success{
    background-color: #97cd76;
    color: #fff;
  }
  .is-black{
    background-color: #464545;
    color: #fff;
  }
  .is-light{
    background-color: #f5f7fa;
    color: #69707a;
  }
</style>
